export const isOnlyForProd = () =>
  window.location.host === "myaccount.brightspeed.com";

export const isChatEnabled = () => {
  const hostname = window.location.hostname.toLowerCase();
  return isOnlyForProd() || /^myaccount(?:next)?\.[a-z0-9-]+-gcp\.brtspd\.co$/.test(hostname);
};

export const chatClick = () => {
  if (!isChatEnabled()) return false;
  window.dispatchEvent(new CustomEvent("chat-launch-request", { detail: "chat" }));
  return true;
};

export const wifiExtenderChatClick = () => {
  if (!isChatEnabled()) return false;
  window.dispatchEvent(new CustomEvent("chat-launch-request", { detail: "wifiExtender" }));
  return true;
};

// The chat controller has no end API; its "ended" handler removes the chat iframe and
// resets the widget so the next launchChat starts a new session. A minimized chat must be
// restored first, otherwise launchChat would try to restore the removed iframe.
export const endChat = () => {
  if (!document.getElementById("chatbox")) return;
  if (typeof window.restoreChat === "function") {
    window.restoreChat();
  }
  window.postMessage({ chatmessage: true, event: "ended" }, window.location.origin);
};
